import React from 'react';
import { solutions } from '../data/mock';
import { BarChart3, FileText, Link, Brain } from 'lucide-react';

const iconMap = {
  BarChart3,
  FileText,
  Link,
  Brain,
};

const SolutionsSection = () => {
  return (
    <section id="features" className="py-20 lg:py-28 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            <span className="md:hidden">E-E-A-T＋独自性を<br />数値で可視化</span>
            <span className="hidden md:inline">E-E-A-T＋独自性を数値で可視化</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            <span className="md:hidden">主観的な判断から脱却し、<br />再現性のある品質評価を実現</span>
            <span className="hidden md:inline">主観的な判断から脱却し、再現性のある品質評価を実現</span>
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => {
            const IconComponent = iconMap[solution.icon];
            return (
              <div
                key={solution.id}
                className="group relative bg-gradient-to-br from-slate-800/80 to-slate-900/80 border border-slate-700/50 rounded-2xl p-8 hover:border-cyan-500/30 transition-all duration-300"
              >
                {/* Number badge */}
                <div className="absolute -top-3 -left-3 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center text-slate-900 font-bold text-sm">
                  {index + 1}
                </div>

                <div className="flex items-start gap-5">
                  {/* Icon */}
                  <div className="flex-shrink-0 w-14 h-14 bg-cyan-500/10 rounded-xl flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors">
                    {IconComponent && (
                      <IconComponent className="w-7 h-7 text-cyan-400" />
                    )}
                  </div>

                  {/* Content */}
                  <div>
                    <h3 className="text-white font-semibold text-xl mb-3">
                      {solution.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed">
                      {solution.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Key differentiator */}
        <div className="mt-16 bg-gradient-to-r from-slate-800/50 via-slate-800 to-slate-800/50 border border-slate-700/50 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
            <div className="flex-shrink-0 w-16 h-16 bg-teal-500/10 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-teal-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className="text-white font-semibold text-lg mb-2">
                人による主観評価との違い
              </h3>
              <p className="text-slate-400">
                担当者ごとに異なる評価基準を統一。編集会議での議論や外注先への指示に、
                <span className="text-teal-400">共通の判断軸</span>として活用できます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;